import { Injectable } from '@angular/core';
import { CapacityService } from '../../shared/services/capacity.service';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import * as fromActions from './capacity.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { CapacityAdapter } from './capacity.adapter';
import { ICapacityResponse, Capacity } from '../../shared/models/capacity.model';
import { of } from 'rxjs/internal/observable/of';
import { IOverrideCapacity } from '@signal/asp-data-commons/lib/interfaces/availability';
import { IResponse } from '@signal/asp-data-commons';


@Injectable()
export class CapacityEffects {
    constructor(
        private actions$: Actions,
        private capacityService: CapacityService
    ) {
    }

    
    loadCapacity: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadCapacity>(
            fromActions.CapacityActionTypes.LOAD_CAPACITY
        ),
        mergeMap((action: fromActions.LoadCapacity) =>
            this.capacityService.getCapacity().pipe(
                switchMap((capacity: ICapacityResponse) => CapacityAdapter.toCapacity(capacity)),
                map((capacity: Capacity[]) => new fromActions.LoadCapacitySuccess({ capacity })),
                catchError(err => of(new fromActions.LoadCapacityFailure({ error: err })))
            )
        )
    ));

    
    updateCapacity: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateCapacity>(
            fromActions.CapacityActionTypes.UPDATE_CAPACITY
        ),
        map((action: fromActions.UpdateCapacity) => action.payload),
        mergeMap((capacity: Capacity) =>
            this.capacityService.updateCapacity(capacity).pipe(
                map(
                    (updatedCapacity: Capacity) =>
                        new fromActions.UpdateCapacitySuccess(updatedCapacity),
                ),
                catchError(err => of(new fromActions.UpdateCapacityFailure({ error: err })))
            ))));

    
    loadCapacityOverride: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadCapacityOverrideForDate>(
            fromActions.CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE
        ),
        mergeMap((action: fromActions.LoadCapacityOverrideForDate) =>
            this.capacityService.getCapacityOverrideForDate(action.payload, 'service').pipe(
                map((capacity: IResponse<IOverrideCapacity>) => new fromActions.LoadCapacityOverrideForDateSuccess(capacity.data)),
                catchError(err => of(new fromActions.LoadCapacityOverrideForDateFailure({ error: err })))
            )
        )
    ))   
    
    updateCapacityOverride: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateCapacityOverride>(
            fromActions.CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE
        ),
        map((action: fromActions.UpdateCapacityOverride) => action.payload),
        mergeMap((capacity: IOverrideCapacity) =>
            this.capacityService.updateCapacityOverrideForDate('service',capacity).pipe(
                map(
                    (updatedCapacity: IResponse<IOverrideCapacity>) =>
                        new fromActions.UpdateCapacityOverrideSuccess(updatedCapacity.data),
                ),
                catchError(err => of(new fromActions.UpdateCapacityOverrideFailure({ error: err })))
            ))));
}       

